module.exports = __webpack_public_path__ + "img/panel1.45a8b60a.svg";